import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import translate from '../../../../../../../commonComponents/translate';
import { colors } from '../../../../../../../services/utilityFunctions';
import InboxContainer from '../InboxContainer';
import PodcastIcon from '../icons/PodcastIcon';

function PodcastMessage({ t, message, onClick }) {
  const { title, info, image, createdAt } = message;

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('dynamic'),
        '--news-item-title': colors('inverse'),
        '--news-item-text': colors('inverse'),
      }}
      image={PodcastIcon}
      title={title}
      createdAt={createdAt}
      link={t('inbox_listenPodcast')}
      onClick={onClick}
    >
      <div className="news-item-content-with-image">
        <div className="news-item-content-text">
          <Linkify>{info}</Linkify>
        </div>
        {!!image?.thumb && (
          <img
            src={image.thumb}
            className="news-item-content-image"
            alt="info"
          />
        )}
      </div>
    </InboxContainer>
  );
}

PodcastMessage.propTypes = {
  t: PropTypes.func.isRequired,
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default translate(PodcastMessage);
